import { createContext } from "react";

const GeneralContext = createContext({
  loggedUser: null,
  setLoggedUser: () => {},
  show_loading: false,
  setShowLoading: () => {},
  windowWidth: 0,
  windowHeight: 0,
  mobile_mode: false,
});

export default GeneralContext;



